import { CircularProgress, Grid } from '@mui/material'
import React from 'react'

interface AllyCardContentProps {
  isLoading: boolean
}

export default function AllyCardContent({ children, isLoading }: React.PropsWithChildren<AllyCardContentProps>) {
  return isLoading ? (
    <Grid item container alignItems='center' justifyContent='center' sx={{ mt: 1 }}>
      <Grid item>
        <CircularProgress color='primary' size={50} />
      </Grid>
    </Grid>
  ) : (
    <>{children}</>
  )
}
